import type { JSX } from 'react'
import { isHasTypeName } from '@/services/RenderService'
import { Header as HeaderType } from '@/types/codegen-contentful'

export function isHeader(content: unknown): content is HeaderType {
  return isHasTypeName(content) && content.__typename === 'Header'
}

interface HeaderProps {
  header: HeaderType
  testId: string
}

export function Header(props: HeaderProps) {
  const Level = `${props.header.level ?? 'h2'}` as keyof JSX.IntrinsicElements
  const size = props.header.size ?? 'text-2xl'
  const color = props.header.color ?? 'text-white'
  const align = props.header.align ?? 'text-left'

  return (
    <header className="relative">
      <Level className={`${size} ${color} ${align} m-0 p-0 font-angelSans font-bold !leading-[1.25]`}>
        {props.header.headerText}
      </Level>
    </header>
  )
}
